<template>
    <VeeForm :validation-schema="sizeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12 mb-2 mb-md-0">
        <form ref="form" @submit="handleSubmit($event, onSizeSubmit)" method="post" :action="this.baseUrl + '/enter-size-submit'" class="size-form">
            <input v-if="tyrePosition != null" type="hidden" name="tyre_position" :value="tyrePosition" />
            <div class="row gx-3 w-100">
                <div class="col-6 col-sm-4" v-for="(option, key) in formattedOptions" :key="key">
                    <template v-if="typeof(selectedSizeOption) != 'undefined' && Object.keys(selectedSizeOption).length > 0">
                        <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                            <Field :id="option.name" v-slot="{ value }" :name="option.name" as="select" class="form-select size-input text-navy" v-model="selectedSizeOption[option.name]" data-bs-custom-class="tooltip-error" data-bs-toggle="tooltip" data-bs-placement="top" :title="errors[option.name]">
                                <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(selectedSizeOption[option.name])">{{ item }}</option>
                            </Field>
                        </Popper>
                    </template>
                    <template v-else>
                        <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                            <Field :id="option.name" v-slot="{ value }" :name="option.name" as="select" class="form-select size-input text-navy" data-bs-custom-class="tooltip-error" data-bs-toggle="tooltip" data-bs-placement="top" :title="errors[option.name]">
                                <option value="" disabled>{{ option.label }}</option>
                                <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                            </Field>
                        </Popper>
                    </template>
                </div>
                <div class="col-6 col-sm-4" :class="tyrePosition != null ? 'd-none' : ''">
                    <Popper :content="errors.size_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.size_postcode ? true : false">
                        <Field id="size_postcode" name="size_postcode" type="text" class="form-control size-postcode" :value="postcode" placeholder="Postcode" />
                    </Popper>
                </div>
                <div class="col-6 col-sm-4">
                    <Field v-if="brand" name="brand" :value="brand" />
                    <button class="btn btn-primary" type="submit">
                        <span class="mb-0">Search By Size</span>
                    </button>
                </div>
            </div>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: [
            'options',
            'postcode',
            'tyrePosition',
            'selectedSizeOption',
            'brand'
        ],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const sizeValidationSchema = yup.object({
                'width': yup.string().required(),
                'profile': yup.string().required(),
                'rim': yup.string().required(),
                'size_postcode': yup.string().required('postcode is a required field').nullable()
            });

            return {
                sizeValidationSchema
            }
        },
        mounted() {

        },
        methods: {
            async onSizeSubmit(values) {
                this.emitter.emit('isLoading', true);
                // take object values and format as array, to use join method on.
                var selected_size = Object.values(values);

                //remove any undefined/null entries from posted values
                const normalizedSizes = selected_size.filter(item => item);

                //formats data with pipes for submission
                var format_size = normalizedSizes.join('|');
                
                await axios.post('/ajax/validate_size/' + format_size)
                .then(response => {
                    if(response.data.size_exists == false) {
                        console.log('Size doesn\'t exist, please try again.');
                    }

                    this.$refs.form.submit();

                    return true;
                })
                .catch(error => {
                    this.emitter.emit('isLoading', false);
                    console.error("There was an error!", error);
                });
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            },
        },
        computed: {
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.options.width },
                    { label: 'Profile', name: 'profile', data: this.options.profile },
                    { label: 'Rim', name: 'rim', data: this.options.rim },
                    { label: 'Speed', name: 'speed', data: this.options.speed },
                    // { label: 'Load', name: 'load', data: this.options.load_index },
                ]
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .size-form {
        .size-input {
            background-color: #fff;
            height: 100%;
            width: 100%;
            margin-bottom: 10px;
            text-transform: capitalize;
            font-weight: 400;
            font-size: 1rem;
            border-radius: 3px;
            padding: 4.5px;
        }
        .btn {
            width: 100%;
            background: #DC453A;
            &:hover {
                filter: brightness(120%);
            }
        }
    }
    .size-postcode {
        padding: 4.5px 10px;
        font-size: 1rem;
    }
</style>